import { Grid, Typography, Link as MuiLink } from "@mui/material";

const Section = ({ items, classes }) =>
  items &&
  Object.keys(items).length > 0 && (
    <Grid item xs={12} sm={12} md={12}>
      <Grid container className={classes.gridNoMargin} spacing={2}>
        <Typography
          style={{
            fontSize: "16px",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          Story-Links:
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {Object.keys(items || {}).map((mediaTitle) =>
            Object.keys(items[mediaTitle]).map((lang) => (
              <div
                key={`${mediaTitle}-${lang}`}
                style={{ display: "flex", flexDirection: "flex-row" }}
              >
                <Typography
                  style={{
                    textDecoration: "underline",
                    fontFamily: "BatonTurbo-Book",
                    color: "#262627",
                    marginLeft: "15px",
                    marginRight: "15px",
                  }}
                >
                  <MuiLink
                    href={items[mediaTitle][lang]}
                    target="_blank"
                    rel="noopener"
                  >
                    {mediaTitleLabels[`${mediaTitle}-${lang}`] ||
                      `${mediaTitle} - ${lang}`}
                  </MuiLink>
                </Typography>
              </div>
            )),
          )}
        </div>
      </Grid>
    </Grid>
  );

const mediaTitleLabels = {
  "20min-de": "20 Minuten",
  "20min-fr": "20 minutes",
  "24heures-fr": "24 heures",
  "annabelle-de": "Annabelle",
  "baz-de": "Basler Zeitung",
  "bilan-fr": "Bilan",
  "bund-de": "Der Bund",
  "bz-de": "Berner Zeitung",
  "cp-de": "Commercial Publishing",
  "cp-fr": "Commercial Publishing",
  "cp-it": "Commercial Publishing",
  "-de": "Content Hub",
  "encore-fr": "Encore",
  "femina-fr": "Femina",
  "-fr": "Content Hub",
  "fuw-de": "Finanz und Wirtschaft",
  "-it": "Content Hub",
  "lb-de": "Der Landbote",
  "le-matin-fr": "Le Matin",
  "lifestyle-de": "20 Minuten Lifestyle",
  "lifestyle-fr": "20 minutes Lifestyle",
  "tagi-de": "Tages Anzeiger",
  "tdg-fr": "Tribune de Genève",
  "tio-it": "Tio",
  "zsz-de": "Zürichsee Zeitung",
  "zul-de": "Zürcher Unterländer",
};

export default Section;
